import gql from 'graphql-tag';

export default gql`
mutation {
  disableFingerprintVerification(input: {}) {
    clientMutationId
    amExportConfig {
      id
      isNew
      authenticationType
      schedule
      sftpHost
      sftpPort
      sftpPath
      sftpUsername
      sftpPassword
      sftpFingerprint
      serverFingerprintEnabled
      serverFingerprintMismatch
    }
    viewer {
      id
    }
  }
}
`;
